import { Component, OnInit, Output, EventEmitter, Input, ViewChild, AfterViewInit } from '@angular/core';
import { SectionValidation } from 'shared/service-clients/om-order';
import { ValidationState } from 'dtp/common/enum-type';

@Component({
  selector: 'samplicity-side-menu-header',
  templateUrl: './side-menu-header.component.html',
  styleUrls: ['./side-menu-header.component.scss'],
})
export class SideMenuHeaderComponent implements OnInit {
  @Input() validation: SectionValidation;
  @Input() header: string;
  @Input() selected = false;
  @Output() goto: EventEmitter<string> = new EventEmitter();

  get valid(): boolean {
    if (this.validation) {
      return this.validation.state === ValidationState.Valid;
    } else {
      return false;
    }
  }

  get error(): boolean {
    if (this.validation) {
      return this.validation.state === ValidationState.Error;
    } else {
      return false;
    }
  }

  get warning(): boolean {
    if (this.validation) {
      return this.validation.state === ValidationState.Warning;
    } else {
      return false;
    }
  }

  constructor() { }

  ngOnInit() {
  }

  onClick() {
    if (this.validation) {
      this.goto.emit(this.validation.name);
    }
  }
}
